import { HttpH4Forms } from "../Http";

export class VisaCareH4CaseAPI {

  public static createH4PetitionerDetails(input: any) {
    var url = "h4forms/create";
    var obj = JSON.stringify(input);
    if (input === "") {
      return { data: [] };
    }
    const resultMethod = HttpH4Forms.axios().post(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {

        return res;
      }).catch((e: any) => {

        return e.response;
      });
    return resultMethod;
  }

  public static updateH4PetitionerDetails(input: any) {

    var url = "h4forms/update";
     
    var obj = JSON.stringify(input);
  
    if (input === "") {
      return { data: [] };
    }
    const resultMethod = HttpH4Forms.axios().put(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {

        return res;
      }).catch((e: any) => {

        return e.response;
      });
    return resultMethod;
  }

  public static getH4PetitionerDetails(input: any) {

    var url = "h4forms/getH4PetitionerDetails/" + input.input;

    if (input === "") {
      return { data: [] };
    }
 
    const resultMethod = HttpH4Forms.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {
 
        return res;
      })
      .catch((e: any) => {
      
        return e.response;
      });

    return resultMethod;
  }


  public static caseflowH4CaseTrackingCreate(input: any) {
    var url = "h4forms/tracking/create";
    var obj = JSON.stringify(input);

    if (input === "") {
      return { data: [] };
    }
    const resultMethod = HttpH4Forms.axios().post(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {

        return res;
      }).catch((e: any) => {

        return e.response;
      });
    return resultMethod;
  }

  public static caseflowH4CaseTrackingUpdate(input: any) {
    var url = "h4forms/tracking/update";
    var obj = JSON.stringify(input);

    if (input === "") {
      return { data: [] };
    }
    const resultMethod = HttpH4Forms.axios().put(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {

        return res;
      }).catch((e: any) => {

        return e.response;
      });
    return resultMethod;
  }

  public static getCaseflowH4CaseTracking(input: any) {

    var url = "h4forms/getH4PetitionTrackingDetails/" + input.input;

    if (input === "") {
      return { data: [] };
    }

    const resultMethod = HttpH4Forms.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {

        return res;
      })
      .catch((e: any) => {
        return e.response;
      });

    return resultMethod;
  }


  public static h4FormPdfSubmit(input: any) {

    var url = "h4forms/generateH4DependantPDFByDependantId/" + input.inputParam + "?companyCode=" + input.inputParamCompanyCode;

    if (input === "") {
      return { data: [] };
    }
   /* var filename = input.input + "_I-539_" + input.inputParam + "_" +  input.inputParamCompanyCode + ".pdf";
    if (input.inputParamDependantType === "CHILD") {
      filename = input.input + "_I-539A_" + input.inputParam + "_" +  "_" + input.inputParamCompanyCode + ".pdf";
    }*/
    const resultMethod = HttpH4Forms.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }, responseType: 'blob'
      })
      .then(res => {

        return res;
      })/*.then(response => response.data)
      .then(blob => {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        a.remove();
        setTimeout(() => window.URL.revokeObjectURL(url), 100);
        alert("Form was created/updated  successfully based on the Changes.");
         window.location.reload();
      })
      .catch((e: any) => {

        return e.response;
      });
*/
    return resultMethod;
  }

}